import { type PrinterPages } from '@justomx/atlas-components'
import { toastSuccess } from 'utils/toast'

export const usePrinter = () => {
  const onPrinterPageChange = (page: PrinterPages) => {
    if (page === 'DETAIL_PAGE') {
      toastSuccess('La impresora se ha sincronizado con tu handheld.')
    }
  }

  return {
    actions: {
      onPrinterPageChange
    }
  }
}
